import styles from './styles.module.css';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';


import Img from "src/assets/images/home/service.webp"
import { isRTL } from 'src/utils/global';


const Services = () => {
    const { t, i18n } = useTranslation("home");


    return (
        <Element data-aos="fade-up" name="services" className={`${styles.services} ${isRTL() && styles.rtl}`}>
            <div className='container'>
                <div className={`row ${styles.row}`}>
                    <div className='col-lg-7 my-auto'>
                        <div className={styles.subTitle}>
                            {t("service.sub_title")}
                        </div>
                        <h2 className={styles.title}>
                            {t("service.title")}
                        </h2>
                        <p className={`${styles.services__text} global-p`}>
                            {t("service.content")}
                        </p>
                    </div>
                    <div className='col-lg-5 d-flex align-items-center'>
                        <div className={styles.img__con}>
                            <img
                                src={Img}
                                alt={t("service.title")}
                                width={460}
                                height={240}
                                loading='lazy'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Element>
    )
}

export default Services;
